<template>
    <div class="product-breadcrumbs">
        <div class="product-breadcrumbs-container">
            <Breadcrumbs :breadcrumbs />
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { Breadcrumb } from '@/components/ui/Breadcrumbs.vue'
import Breadcrumbs from '@/components/ui/Breadcrumbs.vue'

defineProps<{
    breadcrumbs: Breadcrumb[]
}>()
</script>

<style lang="scss" scoped>
.product-breadcrumbs {
    padding: 20px 0;
    background: $white;
    border-top: 1px solid $grey-200;

    .product-breadcrumbs-container {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        max-width: 1440px;
        margin: 0 auto;
        padding: 0 20px;

        @include min-width(1280) {
            padding: 0 40px;
        }
    }
}
</style>
